<template>
  <div>
    <h6>
      <u
        >Receive leg: <b>{{ legType(leg) }}</b></u
      >
    </h6>
    <pair title="Start date" :value="leg.accrualSchedule.startDate" />
    <pair title="End date" :value="leg.accrualSchedule.endDate" />
    <pair title="Tenor" :value="leg.accrualSchedule.tenor" />

    <pair title="Frequency" :value="leg.accrualSchedule.frequency" />
    <pair
      title="Business day convention"
      :value="leg.accrualSchedule.businessDayAdjustment.businessDayConvention"
    />
    <pair
      title="Holiday Calendar"
      :value="leg.accrualSchedule.businessDayAdjustment.holidayCalendarId"
    />
    <pair title="Notional" :value="`${leg.notionalSchedule.amount}`" />
    <pair title="Currency" :value="leg.notionalSchedule.currency" />

    <pair
      v-if="leg.calculation.dayCount !== undefined"
      title="Day count convention"
      :value="leg.calculation.dayCount"
    />
    <pair
      v-if="leg.calculation.index !== undefined"
      title="Index"
      :value="leg.calculation.index"
    />
    <pair
      v-if="leg.calculation.rate !== undefined"
      title="Rate"
      :value="`${leg.calculation.rate}`"
    />
  </div>
</template>

<script>
export default {
  props: {
    leg: {
      type: Object,
      required: true
    }
  },
  methods: {
    legType(leg) {
      if (leg.calculation.index !== undefined) {
        return "Floating";
      } else {
        return "Fixed";
      }
    }
  }
};
</script>
